// Pojistka proti odkazům na cizí instanci v datech vlastního vyhledávání.
//
// PROČ (incident 2026-09-21, `ops/sweeps/2026-09-21-objednavky-na-dev/`):
// obsahová kolekce cz tenantu nesla URL kategorií a značek s hostem dev
// instance 797093.myshoptet.com. Po cutoveru 11. 9. je našeptávač a stránka
// výsledků na ostré vykreslily a zákazníci nakupovali na dev (5 objednávek,
// které do ostré nikdy nedorazily). Zdroj hlídá brána indexeru
// (`search/indexer/host-guard.mjs`); tohle je druhá vrstva v prohlížeči. Chytí
// i to, co brána nevidí: chybnou mapu `TENANTS` (ostrá by četla dev index).
//
// Volá ji výhradně `searchApi.js` nad KAŽDOU odpovědí API (vlastní fetch
// i prefetch z hlavičky) — všechno, co vrstva kreslí (našeptávač, výsledky,
// homepage z `/popular` a `/category-rank`, `/recommend`), teče tudy.
// Odkaz (`url`) s jiným originem, než má stránka, se přepíše na relativní
// cestu (dev je zrcadlo ostré, cesty sedí) a volající jednou za odpověď
// zaloguje `[bs]` chybu — tu pozná `tools/qa/js-health.mjs` v post-deploy sadě.
// Obrázky (`image`) se nepřepisují: nikoho nikam nepošlou a smí být na CDN.

// Pole odkazu v odpovědích API (karta, obsah, pořadí kategorií).
const URL_KEY = /^url$/;
const MAX_DEPTH = 8;

/** Origin stránky (`https://www.jipos.cz`), `null` mimo http(s) — `file://` fixtures. */
export function pageOrigin(loc) {
  try {
    const l = loc || window.location;
    if (l.protocol !== 'https:' && l.protocol !== 'http:') return null;
    return l.protocol + '//' + l.host;
  } catch (e) {
    return null;
  }
}

/** Relativní náhrada cizí URL, nebo `null` (URL je v pořádku / nejde přečíst). */
function localize(value, origin) {
  let u;
  try {
    u = new URL(value, origin);
  } catch (e) {
    return null;
  }
  if (u.protocol + '//' + u.host === origin) return null;
  const http = u.protocol === 'https:' || u.protocol === 'http:';
  return { value: http ? u.pathname + u.search + u.hash : '#', host: http ? u.host : u.protocol };
}

/**
 * Přepíše NA MÍSTĚ každé URL pole `data` s cizím originem na relativní cestu.
 * Vrací `{count, hosts}` — kolik polí se přepsalo a na jaké cizí hosty mířila.
 * Bez originu (fixture na `file://`) nedělá nic.
 */
export function localizeUrls(data, origin) {
  const hosts = [];
  let count = 0;
  if (!origin) return { count, hosts };
  const walk = (node, depth) => {
    if (!node || typeof node !== 'object' || depth > MAX_DEPTH) return;
    if (Array.isArray(node)) {
      for (let i = 0; i < node.length; i++) walk(node[i], depth + 1);
      return;
    }
    const keys = Object.keys(node);
    for (let i = 0; i < keys.length; i++) {
      const k = keys[i];
      const v = node[k];
      if (typeof v === 'string') {
        if (!v || !URL_KEY.test(k)) continue;
        const local = localize(v, origin);
        if (!local) continue;
        node[k] = local.value;
        count += 1;
        if (hosts.indexOf(local.host) < 0) hosts.push(local.host);
      } else if (v && typeof v === 'object') {
        walk(v, depth + 1);
      }
    }
  };
  walk(data, 0);
  return { count, hosts };
}
